import { render, staticRenderFns } from "./TrModal.vue?vue&type=template&id=5bfbe70e&scoped=true"
import script from "./TrModal.vue?vue&type=script&lang=ts"
export * from "./TrModal.vue?vue&type=script&lang=ts"
import style0 from "./TrModal.vue?vue&type=style&index=0&id=5bfbe70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfbe70e",
  null
  
)

export default component.exports